import { AddAnnotationToCard, RemoveAnnotationFromCard } from '@/api/storymapCardDetails/commands';
import { useSendCommandAsync } from '@/_core/cqrs/use';
import { RealTimeAction } from '@/_core/fluxstore/types';
import { StorymapState } from '../../types';
import { getCardById } from '../../use';
import { useStorymapStore } from '../../useModule';

const { registerReducer, registerMiddleware } = useStorymapStore();

export class SetAnnotationIsUsedOnCard extends RealTimeAction<StorymapState> {
    public static ACTION_TYPE = 'SetAnnotationIsUsedOnCard';

    public constructor(
        public cardId: string,
        public annotationId: string,
        public isUsed: boolean,
        public isDispatchedByDetailsModal: boolean = false
    ) {
        super(SetAnnotationIsUsedOnCard.ACTION_TYPE);
    }
}

const middleware = async (state: StorymapState, action: SetAnnotationIsUsedOnCard): Promise<boolean> => {
    const card = getCardById(action.cardId);
    if (!card) {
        return false;
    }

    const annotation = state.annotations.find((x) => x.id === action.annotationId);

    if (!annotation) {
        return false;
    }

    if (!action.isDispatchedByDetailsModal) {
        if (action.isUsed) {
            useSendCommandAsync(action, {
                createCommand: async () =>
                    await AddAnnotationToCard.create(action.cardId, card.title, state.id, action.annotationId, annotation.name),
            });
        } else {
            useSendCommandAsync(action, {
                createCommand: async () =>
                    await RemoveAnnotationFromCard.create(action.cardId, card.title, state.id, action.annotationId, annotation.name),
            });
        }
    }

    return true;
};

const reducer = (state: StorymapState, action: SetAnnotationIsUsedOnCard): void => {
    const card = getCardById(action.cardId);

    if (action.isUsed) {
        card.annotationIds.push(action.annotationId);
    } else {
        card.annotationIds = card.annotationIds.filter((x) => x !== action.annotationId);
    }
};

//@ts-ignore
registerMiddleware(SetAnnotationIsUsedOnCard.ACTION_TYPE, middleware);

//@ts-ignore
registerReducer(SetAnnotationIsUsedOnCard.ACTION_TYPE, reducer);
